import React from "react";

import "./footerup.scss";

const footerup = () => {
  return (
    <div className="footerup">
      <div className="containerfooter">
        <div className="desk1">
          <h1>Visit Us!</h1>
          <div className="alamat">
            Main Boulevard Jl. Jkt Garden City Boulevard, RT.11/RW.8, Cakung
            Tim., Kec. Cakung, Kota Jakarta Timur, Daerah Khusus Ibukota Jakarta
            13910
          </div>
        </div>
        <hr />
        <div className="desk2">
          Dapatkan Informasi Promo, Brosur dan Pricelist Terbaru
        </div>
        <hr />
        <div className="desk3">Contact Us: +628111607096 (Andrian)</div>
      </div>

      <a href="/privacy-policy">Privacy Policy </a>
      <div className="copyright">
        © All Rights Reserved, Jakarta Garden City
      </div>
      <div className="powered">Powered by Linktown</div>
    </div>
  );
};

export default footerup;
